import React from 'react';

import { AuthUser } from '@/api';

interface AuthContextProps {
  isLoggedIn: boolean;
  user: AuthUser | null;
  accessToken: string;
  login: () => void;
  logout: () => void;
  handleLoginSuccess: (accessToken: string, userData: AuthUser, expiresIn: number, refreshToken?: string) => void;
}

const defaultContext: AuthContextProps = {
  isLoggedIn: false,
  user: null,
  accessToken: '',
  login: () => {},
  logout: () => {},
  handleLoginSuccess: () => {},
};

export const AuthContext = React.createContext<AuthContextProps>(defaultContext);

export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};